import axios from "axios";
import { serializeDealBoardFilters } from "@/Utile/ncrmDealBoardFilters.mjs";

const DEAL_BOARD_PAGE_SIZE = 200;
const DEAL_BOARD_MAX_PAGES = 100;

const normalizeDealBoardSearch = (value) => String(value || "").trim();

const normalizeDealListItems = (value) => (Array.isArray(value) ? value : []);

export const buildDealBoardSearchState = () => ({
  searchDebounceId: null,
  dealsRequestSeq: 0,
});

export const dealBoardSearchWatch = {
  search() {
    if (this.searchDebounceId) {
      clearTimeout(this.searchDebounceId);
    }
    this.searchDebounceId = setTimeout(() => {
      this.fetchDeals().catch((error) => {
        console.error("[ncrm-deal-board] search deals error", error);
        this.showSnackbar(
          error?.response?.data?.error || this.$t("ncrm.deals.board.messages.loadError"),
          "error"
        );
      });
    }, 260);
  },
};

export const dealBoardSearchMethods = {
  async fetchDeals() {
    if (!this.boardId) return;
    const requestSeq = Number(this.dealsRequestSeq || 0) + 1;
    this.dealsRequestSeq = requestSeq;
    const baseParams = {
      pipelineId: this.boardId,
      limit: DEAL_BOARD_PAGE_SIZE,
      search: normalizeDealBoardSearch(this.search) || undefined,
      advancedFilters: serializeDealBoardFilters(this.advancedFilters) || undefined,
    };
    const items = [];
    let expectedTotal = null;
    for (let page = 1; page <= DEAL_BOARD_MAX_PAGES; page += 1) {
      const { data } = await axios.get("/ncrm/deals", {
        params: {
          ...baseParams,
          page,
        },
      });
      if (requestSeq !== Number(this.dealsRequestSeq || 0)) return;
      const pageItems = normalizeDealListItems(data?.items);
      items.push(...pageItems);

      const reportedTotal = Number(data?.total);
      if (Number.isFinite(reportedTotal) && reportedTotal >= 0) {
        expectedTotal = Math.trunc(reportedTotal);
      }
      if (expectedTotal !== null && items.length >= expectedTotal) break;
      if (pageItems.length < DEAL_BOARD_PAGE_SIZE) break;
    }
    if (requestSeq !== Number(this.dealsRequestSeq || 0)) return;
    this.deals = items;
  },
};
